import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LorenMapTracesComponent} from './components/loren-map-traces/loren-map-traces.component';
import {LorenAllAssetResolver} from '../loren-assets/resolvers/loren-asset-all.resolver';

const routes: Routes = [
    {
        path: '',
        resolve: {
            assets: LorenAllAssetResolver
        },
        component: LorenMapTracesComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenTracesRoutingModule {
}
